import { combineReducers } from 'redux';
import account from '../users/loggedUser/reducer';
import hotels from '../hotels/reducer';
import cleaning from '../cleaning/reducer';
import messages from '../messages/reducer';
import users from '../users/reducer';
import synchronization from '../synchronization/reducer';
import rooms from '../rooms/reducer';
import roomGroups from '../rooms/groups/reducer';
import occupancy from '../rooms/occupancy/reducer';
import scheduleCleaning from '../cleaning/schedule/reducer';
import loader from '../synchronization/SyncLoader/reducer';
import wallet from '../wallet/reducer';
import payment from '../payment/reducer';
import { reducer as formReducer } from 'redux-form';
import { USER_LOGOUT } from '../users/loggedUser/constants';
const rootReducer = combineReducers({
  account,
  hotels,
  rooms,
  cleaning,
  messages,
  users,
  roomGroups,
  occupancy,
  loader,
  synchronization,
  scheduleCleaning,
  wallet,
  payment,
  form: formReducer
});

export default (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined;
  }

  return rootReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js